<script>
import SidebarLink from './SidebarLink';
import settingsService from '@/services/Settings/settingsService';

export default {
  props: {
    title: {
      type: String,
    },
    backgroundColor: {
      type: String,
      default: '#0e4b2f',
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        const acceptedValues = [
          'primary',
          'info',
          'success',
          'warning',
          'danger',
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink,
    };
  },
  components: {
    SidebarLink,
  },
  computed: {
    /**
     * Styles to animate the arrow near the current active sidebar link
     * @return {{transform: string}}
     */
    arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex;
    },
    shortTitle() {
      return this.title
        .split(' ')
        .map((word) => word.charAt(0))
        .join('')
        .toUpperCase();
    },
    appTitle() {
      return process.env.VUE_APP_TITLE;
    },
  },
  data() {
    return {
      modalidade: process.env.VUE_APP_TYPE,
      submodalidade: process.env.VUE_APP_SUBTYPE,
      linkHeight: 65,
      activeLinkIndex: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      links: [],
      logoUrl: require(process.env.VUE_APP_LOGO_URL),
      titulo: '',
    };
  },
  methods: {
    findActiveLink() {
      this.links.forEach((link, index) => {
        if (link.isActive()) {
          this.activeLinkIndex = index;
        }
      });
    },
    async getSettings() {
      let privateSettings = (await settingsService.getPrivateSettings()) || {};

      this.titulo = privateSettings.platformName || '';
    },
    addLink(link) {
      const index = this.$slots.links.indexOf(link.$vnode);
      this.links.splice(index, 0, link);
    },
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index > -1) {
        this.links.splice(index, 1);
      }
    },
  },
  mounted() {
    this.$watch('$route', this.findActiveLink, {
      immediate: true,
    });
    this.getSettings();
  },
};
</script>

<template>
  <div class="sidebar">
    <!--
            Tip 1: you can change the color of the sidebar's background using: data-background-color="white | black | darkblue"
            Tip 2: you can change the color of the active button using the data-active-color="primary | info | success | warning | danger"
        -->
    <!-- -->
    <div class="sidebar-wrapper" id="style-3">
      <div class="logo" style="text-align: center;">
        <img class="sidebar-logo" :src="logoUrl" alt="">
      </div>
      <slot> </slot>
      <ul class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot name="links">
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="index"
            :to="link.path"
            :name="link.name"
            :icon="link.icon"
          >
          </sidebar-link>
        </slot>
      </ul>
    </div>
  </div>
</template>

<style scoped>
/* sidebar background */
.sidebar-wrapper {
  background: linear-gradient(
    180deg,
    #2b0a4a 0%,
    var(--imob-purple) 100%
  );
}

/* logo */
.sidebar-logo {
  display: block;
  margin: 20px auto 30px auto;
  height: 36px;
  filter: brightness(0) invert(1);
}

/* menu links */
.sidebar-wrapper .nav li a {
  color: rgba(255,255,255,0.85);
  transition: all 0.15s ease;
}

/* hover */
.sidebar-wrapper .nav li a:hover {
  background: rgba(237,34,139,0.12);
  color: var(--imob-white);
}

/* active */
.sidebar-wrapper .nav li.active a {
  background: rgba(237,34,139,0.18);
  border-left: 3px solid var(--imob-magenta);
  color: var(--imob-white);
}
</style>